var global = require('../internals/global');

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/host-report-errors.js
// module id = 1663
// module chunks = 1